import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Popover from '@material-ui/core/Popover';
import Box from '@material-ui/core/Box';
import { KeyboardTimePicker } from '@material-ui/pickers';

import * as Yup from 'yup';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import DialogComponent from 'app/components/DialogComponent';
import { Chip, Collapse, Typography, withStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { hoursOrder } from '../ServicesForms/Lines/utils/filtros';
import notification from '../../config/notification';
import { TIMEZONE_OFFSET } from '../../utils/constants';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import PermissionariesTable from '../ServicesForms/Lines/components/PermissionariesTable';
import uuidUtil from 'app/utils/uuid';
import ConcessionariasTable from '../ServicesForms/Lines/components/ConcessionariasTable';
import { FormServiceContext } from '../../utils/contexts';

const validationSchema = Yup.object().shape({
    hrHorario: Yup.date().required('Campo obrigatório').typeError('Horário inválido').nullable(),
});

const PopoverMenuTable = (props) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [permListVisibleById, setPermListVisibleById] = useState(false);
    const [concListVisibleById, setConcListVisibleById] = useState(false);
    const [columnsToCopy, setColumnsToCopy] = useState([]);
    const [selectedHour, setSelectedHour] = useState(null);
    const [allThisDaySchedules, setAllThisDaySchedules] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);

    const { lineAdministration } = useContext(FormServiceContext);

    const schedulesStore = useSelector((state) => state.line.schedulesStore);
    const empresa = useSelector((state) => state.line.selected?.empresa);
    const scheduleBoard = useSelector((state) => state.line.lineScheduleBoard);
    const isStrip = useSelector((state) => state.line.isStrip);

    const { classes, open, anchorEl, handleClose, dayIndex, route, day, onAddSchedule, onCopyColumn, onClearColumn } =
        props;

    useEffect(() => {
        (() => {
            setErrorMessage(null);
            setSelectedHour(null);
            const filtered = schedulesStore
                .filter((s) => {
                    if (!route || !day || !s) return false;
                    return (
                        s.deSentido.toLowerCase() === route?.toLowerCase() &&
                        s.deDiaSemana.toUpperCase() === day?.toUpperCase()
                    );
                })
                .map((schedule) => {
                    const tempId = schedule.cdLinhaQuadroHorarioHora
                        ? schedule.cdLinhaQuadroHorarioHora
                        : schedule.tempId;
                    return {
                        ...schedule,
                        tempId: tempId,
                        permissionarios: mergeListPermissionariesFromStore(schedulesStore, tempId),
                    };
                });
            setAllThisDaySchedules(hoursOrder(filtered));
        })();
        return () => {
            setAllThisDaySchedules([]);
            setPermListVisibleById(null);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const mergeListPermissionariesFromStore = (schedules, cdLinhaQuadroHorarioHora) => {
        return isStrip
            ? getListConcessionarias(schedules, cdLinhaQuadroHorarioHora)
            : props.permissionaries
                  ?.filter((perm) => perm.boAutorizado)
                  .map((perm) => buildPermissionary(schedules, perm, cdLinhaQuadroHorarioHora));
    };

    const buildPermissionary = (schedules, perm, cdLinhaQuadroHorarioHora) => {
        const permissionaryFromStore = getPermissionaryFromStore(
            schedules,
            cdLinhaQuadroHorarioHora,
            perm.cdLinhaPermissionario,
        );
        return {
            tempId: cdLinhaQuadroHorarioHora,
            cdLinhaQuadroHoraResponsavel: permissionaryFromStore?.cdLinhaQuadroHoraResponsavel,
            cdLinhaPermissionario: perm.cdLinhaPermissionario,
            deCpfCnpj: perm.deCpfCnpj,
            deNomePermissionario: perm.deNomePermissionario,
            nuPermissionario: perm.nuPermissionario,
            boAutorizado: permissionaryFromStore ? permissionaryFromStore.boAutorizado : false,
        };
    };

    const getListConcessionarias = (schedules, cdLinhaQuadroHorarioHora) => {
        const hour = getHourFromSchedules(schedules, cdLinhaQuadroHorarioHora);
        if (!hour.permissionarios) return [];
        return hour.permissionarios.map((perm) => buildConcessionaria(perm));
    };

    const buildConcessionaria = (perm) => {
        return {
            tempId: perm.tempId,
            cdLinhaQuadroHoraResponsavel: perm?.cdLinhaQuadroHoraResponsavel,
            cdLinhaQuadroHorarioHora: perm?.cdLinhaQuadroHorarioHora,
            cnpj: empresa?.deCnpjMatriz,
            cdEmpresa: empresa?.cdEmpresa,
            deRazaoSocial: empresa?.deRazaoSocial,
            boAutorizado: perm.boAutorizado ? perm.boAutorizado : false,
        };
    };

    const getHourFromSchedules = (schedules, tempId) => {
        if (!schedules) return null;
        const hour = schedules.find((hour) => hour.cdLinhaQuadroHorarioHora === tempId || hour.tempId === tempId);

        return hour || null;
    };

    const getPermissionaryFromStore = (schedules, cdLinhaQuadroHorarioHora, cdLinhaPermissionario) => {
        if (!schedules) return null;
        const hour = schedules.find(
            (hour) =>
                hour.cdLinhaQuadroHorarioHora === cdLinhaQuadroHorarioHora || hour.tempId === cdLinhaQuadroHorarioHora,
        );
        if (hour && hour.permissionarios) {
            return hour.permissionarios.find(
                (perm) =>
                    perm.cdLinhaPermissionario === cdLinhaPermissionario || perm.tempId === cdLinhaQuadroHorarioHora,
            );
        }
        return null;
    };

    const openPermListFor = (cdLinhaPermissionario) => {
        setPermListVisibleById(cdLinhaPermissionario === permListVisibleById ? null : cdLinhaPermissionario);
    };

    const openConcessionariaListFor = (cdLinhaConcessionaria) => {
        setConcListVisibleById(cdLinhaConcessionaria === concListVisibleById ? null : cdLinhaConcessionaria);
    };

    const isPermListOpenedFor = (cdLinhaPermissionario) => {
        if (isStrip) return false;
        return cdLinhaPermissionario === permListVisibleById;
    };

    const isConcessionariaListOpenedFor = (cdLinhaConcessionaria) => {
        if (!isStrip) return false;
        return cdLinhaConcessionaria === concListVisibleById;
    };

    const permissionariesCounterBy = (cdLinhaQuadroHorarioHora) => {
        if (!allThisDaySchedules || !cdLinhaQuadroHorarioHora) return 0;
        const schedule = allThisDaySchedules.find(
            (schedule) =>
                schedule.cdLinhaQuadroHorarioHora === cdLinhaQuadroHorarioHora ||
                schedule.tempId === cdLinhaQuadroHorarioHora,
        );
        if (schedule && schedule.permissionarios) {
            return schedule.permissionarios.reduce((count, perm) => {
                return count + (perm.boAutorizado ? 1 : 0);
            }, 0);
        }
        return 0;
    };

    const onCheckPermissionary = (id, listPermissionariesUpdated) => {
        setAllThisDaySchedules(
            allThisDaySchedules.map((schedule) => {
                if (schedule.cdLinhaQuadroHorarioHora === id || schedule.tempId === id) {
                    return {
                        ...schedule,
                        permissionarios: listPermissionariesUpdated,
                    };
                }
                return schedule;
            }),
        );
    };

    const handleSelectColumn = (e) => {
        let selected = [...columnsToCopy];
        if (e.target.checked) selected.push(e.target.value);
        else if (!e.target.checked) selected = selected.filter((el) => el !== e.target.value);
        setColumnsToCopy(selected);
    };

    const handleCopyColumn = () => {
        onCopyColumn({ day, selectedTargets: columnsToCopy });
        setColumnsToCopy([]);
        handleClose();
    };

    const handleClearColumn = () => {
        onClearColumn(day);
        handleClose();
    };

    const setError = ({ message, fieldMessage }) => {
        setErrorMessage(fieldMessage);
        if (message) notification(message, { type: 'error' });
    };

    const compareHour = (scheduleData, entry) => {
        return moment(scheduleData.hrHorario).format('HH:mm') === moment(entry.hrHorario).format('HH:mm');
    };

    const handleDeleteSchedule = (scheduleData) => {
        let newAllSchedules = allThisDaySchedules.map((entry) => {
            const temp = { ...entry };
            if (isTempId(scheduleData.cdLinhaQuadroHorarioHora)) {
                if (temp.cdLinhaQuadroHorarioHora === scheduleData.cdLinhaQuadroHorarioHora) {
                    temp.boExcluido = true;
                }
            } else {
                const found = compareHour(scheduleData, entry);
                if (found) {
                    temp.boExcluido = true;
                }
            }
            return temp;
        });
        setAllThisDaySchedules(hoursOrder(newAllSchedules));
    };

    const isTempId = (id) => {
        return uuidUtil.validate(id);
    };

    const buildNewConcessionaria = (tempId, scheduleBoard) => {
        return [
            {
                cdLinhaQuadroHoraResponsavel: scheduleBoard?.cdLinhaQuadroHorario,
                cdLinhaQuadroHorarioHora: tempId,
                cnpj: empresa?.deCnpjMatriz,
                cdEmpresa: empresa?.cdEmpresa,
                deRazaoSocial: empresa?.deRazaoSocial,
                boAutorizado: true,
            },
        ];
    };

    const prepareNewPermissionary = (tempId, scheduleBoard) => {
        return isStrip
            ? buildNewConcessionaria(tempId, scheduleBoard)
            : props.permissionaries
                  ?.filter((perm) => perm.boAutorizado)
                  .map((perm) => {
                      return {
                          ...buildPermissionary(allThisDaySchedules, perm, tempId),
                          boAutorizado: false,
                      };
                  });
    };

    const prepareNewSchedule = (hrHorario) => {
        const tempId = uuidUtil.generate();
        const newSch = {
            cdLinhaQuadroHorario: scheduleBoard?.cdLinhaQuadroHorario,
            cdLinhaQuadroHorarioHora: tempId,
            deDiaSemana: day.toUpperCase(),
            deSentido: route.toUpperCase(),
            hrHorario: moment(hrHorario).toISOString(),
            isNew: true,
            permissionarios: prepareNewPermissionary(tempId, scheduleBoard),
        };
        const found = allThisDaySchedules.find((entry) => {
            return compareHour(newSch, entry);
        });
        if (found && found.boExcluido) {
            return {
                ...found,
                isNew: isTempId(found.cdLinhaQuadroHorarioHora),
                boExcluido: false,
            };
        } else if (found && !found.boExcluido) {
            setError({ fieldMessage: 'Existem horários duplicados' });
            throw String('O(s) campo(s) sinalizado(s) deve(m) ser preenchido(s) com um horário válido');
        }
        return newSch;
    };

    const validate = async (hrHorario) => {
        return await validationSchema
            .validate({ hrHorario: selectedHour })
            .then(({ hrHorario }) => {
                return hrHorario;
            })
            .catch((err) => {
                return err;
            });
    };

    const handleAddSchedule = async () => {
        const valid = await validate(selectedHour);
        if (valid.errors && valid.errors) {
            setError({
                message: 'O(s) campo(s) sinalizado(s) deve(m) ser preenchido(s) com um horário válido',
                fieldMessage: valid.message,
            });
            return;
        }
        setErrorMessage(null);
        try {
            const newSch = prepareNewSchedule(selectedHour);
            if (newSch) {
                const schedulesData = allThisDaySchedules.filter((entry) => {
                    return !compareHour(newSch, entry);
                });
                schedulesData.push(newSch);
                setAllThisDaySchedules(hoursOrder(schedulesData));
                setSelectedHour(null);
            }
        } catch (e) {
            notification(e.message, { type: 'error' });
        }
    };

    const handleSaveSchedules = async () => {
        let schedulesToSave = [...allThisDaySchedules];
        let valid = false;
        try {
            if (selectedHour && selectedHour !== '') {
                valid = await validate(selectedHour);
                const newSch = prepareNewSchedule(selectedHour);
                if (newSch) {
                    schedulesToSave = schedulesToSave.filter((entry) => {
                        return !compareHour(newSch, entry);
                    });
                    schedulesToSave.push(newSch);
                }
            }
            if (valid && valid.errors) {
                setError({
                    message: 'O(s) campo(s) sinalizado(s) deve(m) ser preenchido(s) com um horário válido',
                    fieldMessage: valid.message,
                });
                return;
            }
            onAddSchedule(schedulesToSave);
            setModalOpen(false);
        } catch (e) {
            notification(e.message, { type: 'error' });
        }
    };

    const handleOpenEditSchedule = () => {
        setModalOpen(() => !modalOpen);
        handleClose();
    };

    const handleClosePopover = () => {
        handleClose();
        setColumnsToCopy([]);
    };

    const DAY_LABEL = [
        'segunda-feira',
        'terça-feira',
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        'sábado',
        'domingo',
    ];

    const fixTimezone = (data) => {
        const currentOffset = moment().utcOffset();
        const offset = data?.isNew ? currentOffset : TIMEZONE_OFFSET.AMERICA_SAOPAULO;
        return moment(data.hrHorario).utcOffset(offset);
    };

    const ScheduleEntry = ({ data }) => {
        return (
            <>
                <ListItem divider>
                    <ListItemText primary={<>{fixTimezone(data).format('HH:mm')}</>} />
                    {lineAdministration && !isStrip && (
                        <ListItemText primary={`${permissionariesCounterBy(data.tempId)} permissionário(s)`} />
                    )}
                    <ListItemSecondaryAction>
                        <span>
                            {data?.isNew && (
                                <Chip size="small" label="novo" color="primary" style={{ marginLeft: '16px' }} />
                            )}
                        </span>
                        <IconButton onClick={() => handleDeleteSchedule(data)}>
                            <DeleteIcon />
                        </IconButton>
                        {lineAdministration && (
                            <>
                                {isStrip ? (
                                    <IconButton onClick={() => openConcessionariaListFor(data.tempId)}>
                                        {isConcessionariaListOpenedFor(data.tempId) ? <ExpandLess /> : <ExpandMore />}
                                    </IconButton>
                                ) : (
                                    <IconButton onClick={() => openPermListFor(data.tempId)}>
                                        {isPermListOpenedFor(data.tempId) ? <ExpandLess /> : <ExpandMore />}
                                    </IconButton>
                                )}
                            </>
                        )}
                    </ListItemSecondaryAction>
                </ListItem>
                <Collapse in={isPermListOpenedFor(data.tempId)} timeout="auto" unmountOnExit>
                    <List>{renderPermissionariesSelectionTable(data)}</List>
                </Collapse>
                <Collapse in={isConcessionariaListOpenedFor(data.tempId)} timeout="auto" unmountOnExit>
                    <List>{renderConcessionariaSelectionTable(data)}</List>
                </Collapse>
            </>
        );
    };

    const renderPermissionariesSelectionTable = (data) => {
        const permissionariesByHour = data.permissionarios;
        if (!permissionariesByHour || !permissionariesByHour.length) {
            return <ListItemText secondary="Nenhum permissionário autorizado." />;
        }
        return (
            <Box marginBottom={4}>
                <PermissionariesTable
                    data={permissionariesByHour}
                    isInternalForm={true}
                    setData={(listPermUpdated) => onCheckPermissionary(data.tempId, listPermUpdated)}
                    isPaginated={false}
                    columnsOrder={{
                        autorizadoComponent: 0,
                        deCpfCnpj: 1,
                        deNomePermissionario: 2,
                        cdLinhaPermissionario: 3,
                    }}></PermissionariesTable>
            </Box>
        );
    };

    const renderConcessionariaSelectionTable = (data) => {
        return (
            <Box marginBottom={4}>
                <ConcessionariasTable
                    data={data.permissionarios}
                    isInternalForm={true}
                    setData={(listPermUpdated) =>
                        onCheckPermissionary(data.tempId, listPermUpdated)
                    }></ConcessionariasTable>
            </Box>
        );
    };

    const editHoursBoard = () => {
        return (
            <DialogComponent
                key={`${route}${day}`}
                open={modalOpen}
                onClose={() => setModalOpen(() => !modalOpen)}
                title={`Horários para ${DAY_LABEL[dayIndex]}`}
                maxWidth="md">
                <Box maxHeight="320px" marginBottom="16px" overflow="auto">
                    <List component="div">
                        {allThisDaySchedules?.length > 0 ? (
                            allThisDaySchedules
                                .filter((entry) => !entry.boExcluido)
                                .map((entry, index) => {
                                    return <ScheduleEntry key={`${entry.cdHorario}${index}`} data={entry} />;
                                })
                        ) : (
                            <Typography variant="h6">Nenhum registro cadastrado</Typography>
                        )}
                    </List>
                </Box>
                <KeyboardTimePicker
                    name="hrHora"
                    label="Novo horário"
                    format="HH:mm"
                    autoOk
                    ampm={false}
                    clearable
                    clearLabel="Limpar"
                    cancelLabel="Cancelar"
                    invalidLabel="Informação inválida"
                    invalidDateMessage="Informação inválida"
                    maxDateMessage="Informação inválida"
                    minDateMessage="Informação inválida"
                    emptyLabel={''}
                    inputVariant="filled"
                    fullWidth
                    value={selectedHour}
                    onChange={setSelectedHour}
                    error={errorMessage && errorMessage}
                    helperText={errorMessage ? errorMessage : ''}
                />
                <Box display="flex" justifyContent="flex-end" padding="16px 0">
                    <Button color="primary" startIcon={<AddIcon />} onClick={handleAddSchedule}>
                        Adicionar
                    </Button>
                </Box>
                <Box display="flex" justifyContent="center" padding="16px">
                    <Button
                        disableElevation
                        variant="contained"
                        color="primary"
                        type="button"
                        className={classes.actionsBtns}
                        onClick={handleSaveSchedules}>
                        <Box className={classes.colorWhite}>Salvar</Box>
                    </Button>
                </Box>
            </DialogComponent>
        );
    };

    return (
        <>
            {editHoursBoard()}
            <Popover
                id="menu-popover"
                open={open}
                anchorEl={anchorEl}
                onClose={handleClosePopover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                disableEnforceFocus>
                <List component="div" disablePadding className={classes.popContent}>
                    <ListItem button onClick={handleOpenEditSchedule}>
                        <ListItemIcon>
                            <EditIcon />
                        </ListItemIcon>
                        <ListItemText>Horários</ListItemText>
                        <ListItemSecondaryAction>
                            <IconButton onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem button onClick={handleClearColumn}>
                        <ListItemIcon>
                            <DeleteIcon />
                        </ListItemIcon>
                        <ListItemText>Limpar coluna</ListItemText>
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemIcon>
                            <FileCopyIcon />
                        </ListItemIcon>
                        <ListItemText>Copiar horários para...</ListItemText>
                    </ListItem>
                    <ListItem>
                        <FormGroup row>
                            <StyledFormControlLabel
                                onChange={handleSelectColumn}
                                disabled={dayIndex === 0}
                                value={0}
                                control={<Checkbox color="primary" />}
                                label="Seg"
                                labelPlacement="bottom"
                            />
                            <StyledFormControlLabel
                                onChange={handleSelectColumn}
                                disabled={dayIndex === 1}
                                value={1}
                                control={<Checkbox color="primary" />}
                                label="Ter"
                                labelPlacement="bottom"
                            />
                            <StyledFormControlLabel
                                disabled={dayIndex === 2}
                                onChange={handleSelectColumn}
                                value={2}
                                control={<Checkbox color="primary" />}
                                label="Qua"
                                labelPlacement="bottom"
                            />
                            <StyledFormControlLabel
                                disabled={dayIndex === 3}
                                onChange={handleSelectColumn}
                                value={3}
                                control={<Checkbox color="primary" />}
                                label="Qui"
                                labelPlacement="bottom"
                            />
                            <StyledFormControlLabel
                                disabled={dayIndex === 4}
                                onChange={handleSelectColumn}
                                value={4}
                                control={<Checkbox color="primary" />}
                                label="Sex"
                                labelPlacement="bottom"
                            />
                            <StyledFormControlLabel
                                disabled={dayIndex === 5}
                                onChange={handleSelectColumn}
                                value={5}
                                control={<Checkbox color="primary" />}
                                label="Sáb"
                                labelPlacement="bottom"
                            />
                            <StyledFormControlLabel
                                disabled={dayIndex === 6}
                                onChange={handleSelectColumn}
                                value={6}
                                control={<Checkbox color="primary" />}
                                label="Dom"
                                labelPlacement="bottom"
                            />
                        </FormGroup>
                    </ListItem>
                    {schedulesStore.length > 0 && columnsToCopy.length > 0 && (
                        <ListItem style={{ justifyContent: 'flex-end' }}>
                            <Button variant="contained" color="primary" size="small" onClick={handleCopyColumn}>
                                Copiar
                            </Button>
                        </ListItem>
                    )}
                </List>
            </Popover>
        </>
    );
};

const StyledFormControlLabel = withStyles({
    labelPlacementBottom: {
        margin: '0 1px',
    },
})(FormControlLabel);

export default PopoverMenuTable;
